// src/components/common/CustomFilters.tsx

import React from 'react';
import { 
  TextInput, 
  SelectInput,
  DateInput, 
  TextInputProps, 
  SelectInputProps,
  DateInputProps 
} from 'react-admin';
import { SxProps } from '@mui/material';

// Common styles for all filters to ensure consistency and alignment
const commonFilterStyles: SxProps = {
  mr: 1, 
  mb: 1.5, 

  // Responsive width: full width on mobile, auto on larger screens
  width: { xs: '100%', sm: 'auto' },

  '& .MuiInputBase-root': {
    height: '40px',
    display: 'flex', 
    alignItems: 'center', 
    paddingRight: '14px',
  },

  '& .MuiInputAdornment-root': {
    height: 'auto',
  },

  '& .MuiSelect-icon': {
    top: 'calc(50% - 12px)',
    right: '8px',
  },

  '& .MuiIconButton-root': {
    padding: '4px',
  },
  
  '& .MuiInputAdornment-positionEnd': {
    marginLeft: 0,
    height: '100%',
    maxHeight: '40px',
    '& .MuiIconButton-root': {
      padding: '8px',
    },
  },
};

// Custom TextInput filter
export const CustomTextInputFilter: React.FC<TextInputProps> = (props) => {
  return (
    <TextInput
      size="small"
      variant="outlined" 
      {...props}
      sx={{ ...commonFilterStyles, ...props.sx }} 
    />
  );
};

// Custom SelectInput filter
export const CustomSelectInputFilter: React.FC<SelectInputProps> = (props) => {
  return (
    <SelectInput
      size="small"
      variant="outlined" 
      {...props}
      sx={{ ...commonFilterStyles, ...props.sx }} 
    />
  );
};

// Custom DateInput filter
export const CustomDateInputFilter: React.FC<DateInputProps> = (props) => {
  return (
    <DateInput
      size="small"
      variant="outlined"
      {...props}
      sx={{ ...commonFilterStyles, ...props.sx }}
    />
  );
};
